import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";

import { rootUrl } from "../actions/constants";

const selectTable = state => state.personRoleSetup;

export const selectedRowSelector = createSelector(
  [selectTable],
  personRoleSetup => personRoleSetup.selectedRow || {}
);

export const selectedIsEditing = createSelector(
  [selectTable],
  personRoleSetup => personRoleSetup.isEditing || false
);
export const registrationTypesSelector = createSelector(
  [selectTable],
  personRoleSetup => personRoleSetup.registrationTypes || []
);
export const personRoleNameLovSelector = createSelector(
  [selectTable],
  personRoleSetup => personRoleSetup.personRoleNameLov || []
);

export const fetchPersonRoleNameLov = createAsyncThunk(
  "personRoleNameLov/browse",
  async (roster, { rejectWithValue }) => {
    if (!roster) {
      return [];
    }
    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${rootUrl}/admin/personrolesetup/${roster}/personrolenamelov`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchRegistrationTypes = createAsyncThunk(
  "registrationTypes/browse",
  async ({ personRoleEnumId, callback }, { rejectWithValue }) => {
    if (!personRoleEnumId) {
      return [];
    }
    try {
      const response = await makeAjaxRequest.postWithAuth(
        `${rootUrl}/admin/personrolesetup/id/${personRoleEnumId}/registrationtypes`,
        {}
      );
      if (callback && typeof callback === "function") {
        callback();
      }
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

const initialState = {
  selectedRow: null,
  isEditing: false,
  personRoleNameLov: [],
  registrationTypes: {
    rows: [],
    loading: false,
    error: null
  }
};

const personRoleSetupSlice = createSlice({
  name: "personRoleSetup",
  initialState,
  reducers: {
    saveSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setIsEditingFlag: (state, action) => {
      state.isEditing = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPersonRoleNameLov.fulfilled, (state, action) => {
      state.personRoleNameLov = action.payload;
    });
    builder.addCase(fetchRegistrationTypes.fulfilled, (state, action) => {
      state.registrationTypes.loading = false;
      state.registrationTypes.rows = action.payload.data;
    });
  }
});
export default personRoleSetupSlice.reducer;
export const { saveSelectedRow, setIsEditingFlag, setEditRowId } = personRoleSetupSlice.actions;
